import styled from "styled-components";

const FeaturePage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: #edf5fa;

  .feature-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid var(--crypto-border-soft);
    padding-bottom: 16px;
  }

  .eyebrow {
    margin-bottom: 8px;
    color: var(--crypto-green);
    font-size: 12px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: 0.06em;
  }

  h1 {
    margin: 0;
    color: #ffffff;
    font-size: 24px;
    line-height: 1.2;
    font-weight: 800;
  }

  .feature-header-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
  }

  .feature-header-actions a,
  .feature-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    border-radius: 8px;
    padding: 0 14px;
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
    text-decoration: none;
    cursor: pointer;
    transition:
      background 160ms ease,
      border-color 160ms ease,
      color 160ms ease,
      transform 160ms ease;
  }

  .feature-header-actions a,
  .feature-button.ghost {
    border: 1px solid var(--crypto-border-soft);
    color: #c7d3df;
    background: var(--crypto-surface-2);
  }

  .feature-button.primary {
    border: 1px solid rgba(89, 244, 119, 0.32);
    color: #0d1713;
    background: var(--crypto-green);
  }

  .feature-button.danger {
    border: 1px solid rgba(255, 111, 111, 0.22);
    color: #ffb6b6;
    background: rgba(255, 111, 111, 0.08);
  }

  .feature-header-actions a:hover,
  .feature-button:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .feature-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .feature-scroll-panel {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .feature-scroll-panel.is-board-loading {
    height: clamp(430px, calc(100vh - 300px), 680px);
    overflow: hidden;
    padding-bottom: 2px;
  }

  .feature-scroll-panel.is-inbox {
    height: clamp(380px, calc(100vh - 260px), 650px);
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-right: 6px;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.54) rgba(255, 255, 255, 0.04);
  }

  .feature-scroll-panel.is-inbox::-webkit-scrollbar {
    width: 7px;
  }

  .feature-scroll-panel.is-inbox::-webkit-scrollbar-track {
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.04);
  }

  .feature-scroll-panel.is-inbox::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(89, 244, 119, 0.54);
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .feature-list.is-board-list {
    gap: 14px;
  }

  .feature-card {
    overflow: hidden;
    border: 1px solid var(--crypto-border-soft);
    border-radius: 12px;
    background: var(--crypto-surface-2);
    transition:
      border-color 180ms ease,
      background 180ms ease,
      box-shadow 180ms ease,
      transform 180ms ease;
  }

  .feature-card.is-open {
    border-color: rgba(89, 244, 119, 0.26);
    background: var(--crypto-surface-1);
    box-shadow: 0 16px 34px rgba(0, 0, 0, 0.18);
  }

  .board-card {
    background: #10242d;
  }

  .board-card-main {
    width: 100%;
    min-width: 0;
    display: grid;
    grid-template-columns: clamp(190px, 27vw, 320px) minmax(0, 1fr);
    gap: 18px;
    align-items: stretch;
    border: 0;
    padding: 14px;
    color: inherit;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  .board-card-main.no-media {
    grid-template-columns: minmax(0, 1fr);
    min-height: 98px;
    padding: 18px 20px;
  }

  .board-skeleton {
    pointer-events: none;
  }

  .board-skeleton .board-card-main {
    cursor: default;
  }

  .board-skeleton .board-card-copy {
    justify-content: center;
  }

  .board-skeleton-media,
  .skeleton-line {
    position: relative;
    overflow: hidden;
    background: linear-gradient(
      90deg,
      rgba(177, 205, 224, 0.07) 0%,
      rgba(177, 205, 224, 0.14) 42%,
      rgba(177, 205, 224, 0.07) 78%
    );
    background-size: 220% 100%;
    animation: boardSkeletonSweep 1.25s ease-in-out infinite;
  }

  .board-skeleton-media {
    border-color: rgba(177, 205, 224, 0.08);
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.04);
  }

  .skeleton-line {
    display: block;
    border-radius: 999px;
  }

  .skeleton-title {
    width: min(360px, 58%);
    height: 24px;
  }

  .skeleton-action {
    width: 88px;
    height: 30px;
  }

  .board-skeleton.no-media .skeleton-title {
    width: min(420px, 72%);
  }

  .board-card-main:hover {
    background: rgba(255, 255, 255, 0.025);
  }

  .board-card-media {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    aspect-ratio: 4 / 3;
    border-radius: 10px;
    border: 1px solid rgba(177, 205, 224, 0.12);
    background: #081922;
  }

  .board-card-media img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    object-position: center;
    transition: filter 220ms ease;
  }

  .board-card-main:hover .board-card-media img {
    filter: brightness(0.86);
  }

  .board-card-media-empty {
    color: rgba(89, 244, 119, 0.82);
    font-size: 42px;
    font-weight: 800;
    box-shadow: inset 0 0 0 1px rgba(89, 244, 119, 0.12);
  }

  .board-card-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    padding: 6px 4px;
  }

  .board-card-kicker {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 9px;
    color: #8fa4b5;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  }

  .board-card-kicker time {
    color: #8fa4b5;
  }

  .board-card-copy strong {
    color: #ffffff;
    font-size: 20px;
    line-height: 1.35;
    font-weight: 800;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }

  .board-card-action {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 8px;
    padding: 0 11px;
    color: #101812;
    background: var(--crypto-green);
    font-size: 12px;
    line-height: 1;
    font-weight: 800;
  }

  .board-detail-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .board-detail-image {
    margin: 0;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid rgba(177, 205, 224, 0.12);
    background: #071922;
  }

  .board-detail-image img {
    width: 100%;
    max-height: min(70vh, 760px);
    display: block;
    object-fit: contain;
  }

  .board-detail-html {
    padding: 2px 1px;
  }

  .board-no-content {
    margin: 0;
    color: #93a6b6;
    font-size: 13px;
    font-weight: 600;
  }

  @keyframes boardSkeletonSweep {
    0% {
      background-position: 110% 0;
    }

    100% {
      background-position: -110% 0;
    }
  }

  .feature-card-summary {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 42px;
    align-items: stretch;
    min-height: 68px;
  }

  .feature-card-main,
  .feature-delete {
    border: 0;
    color: inherit;
    background: transparent;
    cursor: pointer;
  }

  .feature-card-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-width: 0;
    padding: 15px 18px;
    text-align: left;
  }

  .feature-card-main:hover {
    background: rgba(255, 255, 255, 0.025);
  }

  .feature-card-title {
    display: flex;
    align-items: center;
    min-width: 0;
    color: #f6fbff;
    font-size: 15px;
    line-height: 1.42;
    font-weight: 700;
    word-break: keep-all;
    overflow-wrap: anywhere;
  }

  .new-dot {
    flex: 0 0 auto;
    width: 7px;
    height: 7px;
    border-radius: 999px;
    margin-right: 9px;
    background: var(--crypto-green);
    box-shadow: 0 0 10px rgba(89, 244, 119, 0.5);
  }

  .feature-card-meta {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 auto;
    gap: 10px;
    color: #94a6b8;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
  }

  .status-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 58px;
    height: 24px;
    border-radius: 999px;
    padding: 0 9px;
    font-size: 11px;
    font-weight: 800;
  }

  .status-pill.is-new {
    color: #0d1713;
    background: var(--crypto-green);
  }

  .status-pill.is-read {
    color: #a9b8c7;
    background: rgba(255, 255, 255, 0.06);
  }

  .status-pill.is-waiting {
    color: #d2bd84;
    background: rgba(224, 184, 87, 0.12);
  }

  .feature-delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgba(255, 255, 255, 0.04);
    color: #8fa0b0;
  }

  .feature-delete:hover {
    color: #ffb6b6;
    background: rgba(255, 111, 111, 0.08);
  }

  .feature-delete svg {
    width: 18px;
    height: 18px;
  }

  .feature-delete path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .feature-card-detail {
    display: grid;
    grid-template-rows: 0fr;
    border-top: 1px solid transparent;
    transition:
      grid-template-rows 220ms ease,
      border-color 220ms ease;
  }

  .feature-card.is-open .feature-card-detail {
    grid-template-rows: 1fr;
    border-color: rgba(255, 255, 255, 0.05);
  }

  .feature-card-detail-inner {
    min-height: 0;
    overflow: hidden;
    padding: 0 18px;
  }

  .feature-card.is-open .feature-card-detail-inner {
    padding-top: 16px;
    padding-bottom: 18px;
  }

  .feature-card-detail-inner section + section {
    margin-top: 18px;
  }

  .feature-card-detail-inner h3 {
    margin: 0 0 9px;
    color: #ffffff;
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
  }

  .feature-html {
    max-width: 100%;
    color: #c1ceda;
    font-size: 13px;
    line-height: 1.68;
    overflow-wrap: anywhere;
  }

  .feature-html * {
    max-width: 100%;
    font-size: inherit;
    line-height: inherit;
    overflow-wrap: anywhere;
  }

  .feature-html p {
    margin: 0 0 8px;
  }

  .feature-html img {
    display: block;
    max-width: min(100%, 720px);
    height: auto;
    border-radius: 10px;
    margin: 12px 0;
  }

  .empty-state {
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--crypto-border-soft);
    border-radius: 12px;
    color: #94a6b8;
    background: var(--crypto-surface-2);
    font-size: 14px;
    font-weight: 600;
  }

  .feature-load-sentinel {
    flex: 0 0 auto;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #788b9f;
    font-size: 12px;
    font-weight: 700;
  }

  .feature-compose-backdrop,
  .feature-dialog-backdrop {
    position: fixed;
    inset: 0;
    z-index: 205;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
    background: rgba(4, 9, 13, 0.64);
    animation: featureFade 160ms ease both;
  }

  .feature-compose-panel,
  .feature-dialog-panel {
    width: min(620px, 100%);
    border: 1px solid var(--crypto-border);
    border-radius: 14px;
    background: #0f232d;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.42);
    animation: featurePop 180ms ease both;
  }

  .feature-compose-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 22px;
  }

  .feature-compose-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .feature-compose-head strong,
  .feature-dialog-panel strong {
    color: #ffffff;
    font-size: 20px;
    line-height: 1.2;
    font-weight: 800;
  }

  .feature-compose-head button {
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 8px;
    color: #aebccb;
    background: rgba(255, 255, 255, 0.05);
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
  }

  .feature-compose-panel label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #a9b8c7;
    font-size: 13px;
    font-weight: 800;
  }

  .feature-compose-panel input,
  .feature-compose-panel textarea {
    width: 100%;
    border: 1px solid var(--crypto-border-soft);
    border-radius: 10px;
    padding: 13px 14px;
    color: #f6fbff;
    background: rgba(4, 12, 18, 0.58);
    font-size: 14px;
    line-height: 1.5;
    outline: none;
    resize: vertical;
  }

  .feature-compose-panel input:focus,
  .feature-compose-panel textarea:focus {
    border-color: rgba(89, 244, 119, 0.45);
  }

  .feature-compose-actions,
  .feature-dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .feature-dialog-panel {
    max-width: 420px;
    padding: 24px;
  }

  .feature-dialog-panel p {
    margin: 10px 0 0;
    color: #a9b8c7;
    font-size: 14px;
    line-height: 1.55;
    font-weight: 500;
  }

  .feature-dialog-panel.success {
    border-color: rgba(89, 244, 119, 0.28);
  }

  .feature-dialog-panel.error {
    border-color: rgba(255, 111, 111, 0.26);
  }

  .feature-dialog-actions {
    margin-top: 22px;
  }

  @keyframes featureFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes featurePop {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 720px) {
    gap: 14px;

    .feature-header {
      align-items: flex-start;
      flex-direction: column;
    }

    .feature-header-actions {
      width: 100%;
      justify-content: flex-start;
    }

    .feature-header-actions a,
    .feature-button {
      height: 36px;
      padding: 0 12px;
      font-size: 12px;
    }

    .feature-card-summary {
      grid-template-columns: minmax(0, 1fr) 38px;
      min-height: 0;
    }

    .feature-card-main {
      align-items: flex-start;
      flex-direction: column;
      gap: 9px;
      padding: 14px;
    }

    .feature-card-title {
      font-size: 14px;
    }

    .board-card-main {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 12px;
    }

    .board-card-media {
      min-height: 0;
      width: 100%;
    }

    .board-card-copy {
      gap: 8px;
      padding: 2px 0 0;
    }

    .board-card-copy strong {
      font-size: 16px;
      line-height: 1.34;
    }

    .board-card-preview {
      font-size: 12px;
      line-height: 1.5;
      -webkit-line-clamp: 3;
    }

    .board-card-action {
      height: 28px;
      padding: 0 10px;
      font-size: 11px;
    }

    .feature-card-meta {
      width: 100%;
      justify-content: space-between;
      gap: 8px;
    }

    .feature-scroll-panel.is-inbox {
      height: min(62vh, 520px);
      padding-right: 4px;
    }

    .feature-scroll-panel.is-board-loading {
      height: clamp(340px, calc(100vh - 230px), 520px);
    }

    .feature-card-detail-inner {
      padding: 0 14px;
    }

    .feature-card.is-open .feature-card-detail-inner {
      padding-top: 14px;
      padding-bottom: 16px;
    }

    .feature-compose-backdrop,
    .feature-dialog-backdrop {
      align-items: flex-end;
      padding: 12px;
    }

    .feature-compose-panel {
      max-height: calc(100vh - 24px);
      overflow-y: auto;
      padding: 18px;
    }

    .feature-compose-actions,
    .feature-dialog-actions {
      flex-direction: column-reverse;
    }

    .feature-compose-actions .feature-button,
    .feature-dialog-actions .feature-button {
      width: 100%;
    }
  }
`;

export default FeaturePage;
